import { useComputed, useSignal } from "@preact/signals-react"
import { useCallback, useEffect } from "react"
import { getSubmit, postSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import { dateToString } from "Pages/ReportsAlerts/Reports/@utils"
import { europcarCompaniesFilter, europcarDateRange, europcarSitesFilter, europcarUsersFilter } from "Pages/BusinessLogistics/Analytics/Page/@signals"

export default function useInfoBlockData(requestType, isPost = false) {
	const data = useSignal({})
	const isLoading = useSignal(false)
	const { showToast } = useToast()
	const callbackMethod = isPost ? postSubmit : getSubmit

	const deps = useComputed(() => ({
		company: europcarCompaniesFilter.value,
		uid: europcarUsersFilter.value,
		sites: europcarSitesFilter.value,
		startBookingDate: dateToString(europcarDateRange.value[0]),
		endBookingDate: dateToString(europcarDateRange.value[1]),
	}))

	const getData = useCallback(() => {
		isLoading.value = true
		callbackMethod(`${BACKEND_APIS.EUROPCAR_ANALYTICS}/${requestType}`, deps.value)
			.then(res => {
				data.value = res
			})
			.catch(() => {
				showToast.error(`Failed to retrieve ${requestType} data`)
			})
			.finally(() => {
				isLoading.value = false
			})
	}, [deps.value])

	useEffect(() => {
		getData()
	}, [deps.value])

	return {
		res: data.value,
		isLoading: isLoading.value,
	}
}
